import * as React from 'react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { Navigate, useNavigate } from 'react-router-dom';
import { BasicPageWidget } from '../../widgets/layout/BasicPageWidget';
import { InputContainerWidget } from '../../widgets/forms/InputContainerWidget';
import { TextInputType, TextInputWidget } from '../../widgets/forms/TextInputWidget';
import { ButtonType, ButtonWidget } from '../../widgets/controls/ButtonWidget';
import { useSystem } from '../../hooks/useSystem';
import { observer } from 'mobx-react';
import { FooterWidget } from '../../widgets/layout/FooterWidget';
import { Notification, NotificationType } from '../../core/stores/NotificationStore';
import { Routing } from '../Routing';

const logo = require('../../../media/logo.png');

export const ForgotPasswordPage: React.FC = observer(() => {
  const system = useSystem();
  const form = useFormik<{ email: string }>({
    initialValues: {
      email: null
    },
    isInitialValid: false,
    validate: async ({ email }) => {
      if (!email) {
        return {
          email: 'Required'
        };
      }
      return false;
    },
    onSubmit: async ({ email }) => {
      try {
        //send to server
        await system.auth_client.forgotPassword({
          email: email
        });
        system.notification_store.showNotification(
          new Notification({
            type: NotificationType.SUCCESS,
            desc: 'Please check your email for a reset link.'
          })
        );
        navigate(Routing.HOME);
      } catch (ex) {
        system.notification_store.showNotification(
          new Notification({
            type: NotificationType.ERROR,
            desc: 'Failed to send reset password request, please try again later.'
          })
        );
        console.error('failed to reset password', ex);
      }
    }
  });
  const navigate = useNavigate();
  if (system.user) {
    return <Navigate to={Routing.HOME} />;
  }

  return (
    <BasicPageWidget>
      <S.Container>
        <S.Logo src={logo} />
        <InputContainerWidget label="Email">
          <TextInputWidget
            type={TextInputType.EMAIL}
            value={form.values.email}
            onChange={form.getFieldHelpers('email').setValue}
          />
        </InputContainerWidget>
        <S.Buttons>
          <ButtonWidget
            disabled={!form.isValid}
            loading={form.isSubmitting}
            label="Reset password"
            action={() => {
              form.submitForm();
            }}
          />
          <ButtonWidget
            type={ButtonType.SECONDARY}
            label="Back"
            action={() => {
              navigate(Routing.HOME);
            }}
          />
        </S.Buttons>
      </S.Container>
      <FooterWidget />
    </BasicPageWidget>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
    justify-content: center;
    height: 100%;
  `;

  export const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    align-items: stretch;
    width: 250px;
  `;

  export const Logo = styled.img`
    width: 300px;
  `;
}
